import { assetsGlobalVar } from '../store/assets-store'
import { AssetId } from '../types'

export const getAssetById = (assetId: AssetId) => {
  const assetsList = assetsGlobalVar()

  return assetsList?.find(asset => asset.id === assetId)
}

export const getAssetPrecision = (assetId?: AssetId | string | null) => {
  if (!assetId) return undefined

  const precision = getAssetById(assetId as AssetId)?.precision

  return Number.isFinite(precision) ? precision : undefined
}
